import React from 'react';
import { Box, Chip, Typography } from '@mui/material';


const PageHeader = ({ title, subtitle, count, actions, sx = {} }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: { xs: 'flex-start', sm: 'center' },
      justifyContent: 'space-between',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 1.5,
      mb: 2.5,
      ...sx,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
      <Typography
        sx={{
          fontSize: '1.35rem',
          fontWeight: 700,
          color: '#0f172a',
          fontFamily: "'Fira Sans', sans-serif",
          letterSpacing: '-0.01em',
          lineHeight: 1.2,
        }}
      >
        {title}
      </Typography>

      {count != null && count > 0 && (
        <Chip
          label={`${Number(count).toLocaleString('fr-FR')} résultat${count > 1 ? 's' : ''}`}
          size="small"
          sx={{
            background: '#ebf4fb',
            color: '#03407b',
            fontWeight: 600,
            fontSize: '0.8125rem',
            border: '1px solid #aed6f1',
            height: 22,
          }}
        />
      )}

      {subtitle && (
        <Typography sx={{ fontSize: '1rem', color: '#64748b', fontFamily: "'Fira Sans', sans-serif" }}>
          {subtitle}
        </Typography>
      )}
    </Box>

    {actions && (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
        {actions}
      </Box>
    )}
  </Box>
);

export default PageHeader;
